/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, checkValidation } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
// eslint-disable-next-line
import { Row, Col, Button } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const BlueskyField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [inputField, setInputField] = useState({
		bluesky: ''
	});
	const [validation, setValidation] = useState({
		error_bluesky: ''
	});

	useEffect(() => {
		if (props.id) {
			const { bluesky } = lodgeData.social;
			setInputField({ ...inputField, bluesky });
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};
	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;
		var checkError = checkValidation(inputField.bluesky, 'url');
		if (!inputField.bluesky) {
			errors.error_bluesky = pageLanguageContent['CLD071'];
			errorCount++;
		} else if (!checkError) {
			errors.error_bluesky = pageLanguageContent['CLD077'];
			errorCount++;
		} else {
			errors.error_bluesky = '';
		}
		var sendData = {};
		sendData['value'] = inputField['bluesky'];
		sendData['type'] = 'bluesky';

		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('social', inputField['bluesky'], 'bluesky', '');
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}
	return (
		<Row className='mt-2'>
			<Col lg={12}>
				<FormGroupInput
					id='bluesky'
					label={pageLanguageContent['CLD160'] ? pageLanguageContent['CLD160'] : ''}
					placeholder={pageLanguageContent['CLD181'] ? pageLanguageContent['CLD181'] : ''}
					type='text'
					name='bluesky'
					onChange={inputsHandler}
					value={inputField.bluesky}
				/>
				{validation.error_bluesky && <p className='formValidationError'>{validation.error_bluesky}</p>}
			</Col>
			<Col lg={12}>
				{inputField.bluesky && (
					<p style={{ position: 'absolute' }}>
						<a
							href={inputField.bluesky}
							target='_blank'
							rel='noopener noreferrer'
							data-toggle='tooltip'
							title={inputField.bluesky}
						>
							{pageLanguageContent['CLD190'] ? pageLanguageContent['CLD190'] : ''}
						</a>
					</p>
				)}
				<Button
					variant='primary'
					id={'confirmValidatebutton'}
					style={{ float: 'right', marginBottom: '15px' }}
					onClick={updateData}
				>
					{showLoader ? (
						<img src={image_loader} alt='loader' height='20' width='20' />
					) : pageLanguageContent['CLD124'] ? (
						pageLanguageContent['CLD124']
					) : (
						''
					)}
				</Button>
			</Col>
		</Row>
	);
};
export default BlueskyField;
